import h from 'hyperscript';
import { on } from 'cadenza/utils/event-util';

import { FlatpickrAbstractPlugin, isElementInRange } from './flatpickr-abstract-plugin';

const SHIFTS = {
  37: -1,
  39: 1,
  40: 3,
  38: -3
};
const PLUGIN_NAME = 'monthSelect';
const ELEMENTS_PER_PAGE = 12;
const ELEMENTS_CONTAINER_CLASS = 'd-flatpickr-months';
const ELEMENT_CLASS = 'd-flatpickr-month';
const ELEMENT_DISABLE_CLASS = 'flatpickr-disabled';

export class MonthSelectPlugin extends FlatpickrAbstractPlugin {

  constructor () {
    super({ pluginName: PLUGIN_NAME, elementsPerPage: ELEMENTS_PER_PAGE, shifts: SHIFTS });
  }

  clearUnnecessaryDOMElements () {
    super.clearUnnecessaryDOMElements();
    this._fp.monthNav.querySelector('.arrowUp').remove();
    this._fp.monthNav.querySelector('.arrowDown').remove();
  }

  /* Don't set the date from here anymore otherwise when navigating currentYear will be the same as selectedDate...
   By default in the flatpicker dates are not set when navigating, so keep it that way.
   */
  addMonthNavEventListeners () {
    this._monthNavEventKeys = [
      on(this._fp.prevMonthNav, 'mousedown', event => {
        event.stopImmediatePropagation();
        this._fp.currentYear -= 1;
        this.addElements();
        this._fp.yearElements[0].value = this._fp.currentYear.toString(); // Needed because we don't set the date from here anymore, and updateNavigationCurrentMonth runs before this
        this.updateElementsStyle();
      }),
      on(this._fp.nextMonthNav, 'mousedown', event => {
        event.stopImmediatePropagation();
        this._fp.currentYear += 1;
        this.addElements();
        this._fp.yearElements[0].value = this._fp.currentYear.toString();
        this.updateElementsStyle();
      }),
      on(this._fp.yearElements[0], 'change', event => {
        event.stopImmediatePropagation();
        this._fp.currentYear = event.target.value;
        this.addElements();
        this.updateElementsStyle();
      })
    ];
  }

  addElements () {
    if (!this._fp.rContainer) {
      return;
    }
    this.cleanElementsContainer(this._elementsContainer);
    this._elementsEventKeys = [];
    this._elements = [ ...Array(ELEMENTS_PER_PAGE).keys() ].map(monthIndex => {
      const monthElement = h(`span.${ELEMENT_CLASS}`, {
        textContent: monthToStr(monthIndex, this._fp.config.shorthand, this._fp.l10n),
        tabIndex: -1,
        '$i': monthIndex,
        dateObj: new Date(this._fp.currentYear, monthIndex)
      });
      if (isElementInRange(monthElement.dateObj, this._fp.config.minDate, this._fp.config.maxDate)) {
        this._elementsEventKeys.push(
          on(monthElement, 'click', event => this.onClickElement(event)),
          on(monthElement, 'mouseover', event => this.onMouseoverElement(event))
        );
      } else {
        monthElement.classList.add(ELEMENT_DISABLE_CLASS);
      }

      return monthElement;
    });
    this._elementsContainer = h(`.${ELEMENTS_CONTAINER_CLASS}`, { tabIndex: -1 }, this._elements);
    this._fp.rContainer.appendChild(this._elementsContainer);
  }

  updateNavigationCurrentMonth () {
    this._fp._hidePrevMonthArrow = this._fp.config.minDate !== undefined && this._fp.currentYear === this._fp.config.minDate.getFullYear();
    this._fp._hideNextMonthArrow = this._fp.config.maxDate !== undefined && this._fp.currentYear === this._fp.config.maxDate.getFullYear();
  }

  isOnCurrentPage (selectedDate) {
    return selectedDate.getFullYear() === this._fp.currentYear;
  }

  _getClickedElement (selectedDate) {
    const currentlySelectedMonth = selectedDate.getMonth();
    return this._elements[currentlySelectedMonth];
  }

  setDate (date) {
    this._fp.currentMonth = date.getMonth();
    super.setDate(date);
  }

}

function monthToStr (monthNumber, shorthand, locale) {
  return locale.months[shorthand ? 'shorthand' : 'longhand'][monthNumber];
}
